module.exports = __webpack_public_path__ + "img/icon21.bb1016ac.png";